import styled from 'styled-components';

export const NavigationButton = styled.div`
  width: 65px;
  height: 65px;
  text-align: center;
  line-height: 50px;
  border-radius: 100%;
  color: ${props => props.theme.color.wfWhite};
  &:hover {
    background-color: ${props => props.theme.color.wfWhite};
    color: ${props => props.theme.color.wfGrey500};
    cursor: pointer;
  }
`;

export const NavigationButtonText = styled.span`
  font-size: ${props => props.theme.font.size.xsmall};
  font-weight: 400;
  position: absolute;
  top: 21px;
  left: 24px;
`;

export const HamburgerButtonStyled = styled.button`
  width: 28px;
  height: 28px;
  padding-top: 8px;
  transition: all 0.15s linear;
  text-transform: none;
  background-color: transparent;
  border: 0;
  overflow: visible;
`;

export const BurguerBoxStyled = styled.span`
  display: inline-flex;
  justify-content: center;
  position: relative;
`;

export const BurgerInnerStyled = styled.span`
  display: flex;
  margin-top: -2px;
  top: auto;
  bottom: 0;
  transition: transform  0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19) 0.13s;
  &,
  &::before,
  &::after {
    width: 28px;
    height: 2px;
    background-color: inherit;
    border-radius: 2px;
    position: absolute;
    background-color: ${props => props.theme.color.primary};
  }
  &::before,
  &::after {
    content: '';
    display: block;
  }
  &::before {
    top: -8px;
    transition: top 0.12s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), transform 0.13s cubic-bezier(0.55, 0.055, 0.675, 0.19);
  }
  &::after {
    top: -16px;
    transition: top 0.2s 0.2s cubic-bezier(0.33333, 0.66667, 0.66667, 1), opacity 0.1s linear; }

  }
  ${props =>
    props.isActive &&
    `
    transform: translate3d(0, -9px, 0) rotate(-45deg);
    transition-delay: 0.22s;
    transition-timing-function: cubic-bezier(0.215, 0.61, 0.355, 1);
    &::after {
      top: 0;
      opacity: 0;
      transition: top 0.2s cubic-bezier(0.33333, 0, 0.66667, 0.33333), opacity 0.1s 0.22s linear; 
    }
    &::before {
      top: 0;
      transform: rotate(-90deg);
      transition: top 0.1s 0.16s cubic-bezier(0.33333, 0, 0.66667, 0.33333), transform 0.13s 0.25s cubic-bezier(0.215, 0.61, 0.355, 1); 
    }
  `}
`;
